module.exports = __webpack_public_path__ + "media/images/regional-image19-90fd0bab8a48244a5e2341361c07b132.jpg";